import React, {Fragment} from 'react';

import {Button} from '@mui/material';
import {Modal, StyledGrid} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {ShortcutCard} from 'presentation/pages/private/home/components/ShortcutCard';
import {translations} from 'presentation/translations-new';
import {useAppointmentTypeSelect} from './hooks/useAppointmentTypeSelect';
import {AppointmentTypeSelectProps} from './types';

const {close} = translations['pt-br'].commons;
const {selectAppointmentTypeModal} = translations['pt-br'].privateFlow.myAppointments;

export function AppointmentTypeSelect({open, onClose, onOpen}: AppointmentTypeSelectProps) {
	const {isMobile, APPOINTMENT_TYPE, handleSelectAppointment} = useAppointmentTypeSelect({
		onClose,
	});

	return (
		<Fragment>
			{isMobile ? (
				<Drawer.Root open={open} onClose={onClose} onOpen={onOpen} disableSwipeToOpen>
					<Drawer.Header title={selectAppointmentTypeModal.title} onClose={onClose} />

					<Drawer.Content>
						<StyledGrid.Root>
							{APPOINTMENT_TYPE.map(type => (
								<StyledGrid.Item key={type.title} xs={12} sm={6} md={6} lg={6}>
									<ShortcutCard
										handleClick={() => handleSelectAppointment(type)}
										dataTagId={type.dataTagId}
										dataTestId={type.dataTestId}
										hasEmphasis={type.hasEmphasis}
										icon={type.icon}
										title={type.title}
									/>
								</StyledGrid.Item>
							))}
						</StyledGrid.Root>
					</Drawer.Content>
				</Drawer.Root>
			) : (
				<Modal.Root
					onClose={onClose}
					open={open}
					slotProps={{
						paper: {
							sx: {
								maxWidth: 450,
							},
						},
					}}>
					<Modal.Header onClose={onClose} title={selectAppointmentTypeModal.title} />
					<Modal.Content>
						<StyledGrid.Root>
							{APPOINTMENT_TYPE.map(type => (
								<StyledGrid.Item key={type.title} xs={12} sm={6} md={6} lg={6}>
									<ShortcutCard
										handleClick={() => handleSelectAppointment(type)}
										dataTagId={type.dataTagId}
										dataTestId={type.dataTestId}
										hasEmphasis={type.hasEmphasis}
										icon={type.icon}
										title={type.title}
										breakTitle
									/>
								</StyledGrid.Item>
							))}
						</StyledGrid.Root>
					</Modal.Content>
					<Modal.Footer>
						<Button
							fullWidth
							size="large"
							variant={'contained'}
							color={'primary'}
							onClick={onClose}>
							{close}
						</Button>
					</Modal.Footer>
				</Modal.Root>
			)}
		</Fragment>
	);
}
